// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1bMCj","header":"ReportDetails_header__1B43O","title":"ReportDetails_title__1I_jY","left":"ReportDetails_left__2_xbk"};